import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'softcat:components/button.tsx';
import { ErrorMessage } from 'softcat:components/error-message.tsx';

type FormFooterProperties = {
    disabled?: boolean;
    isSubmitting: boolean;
    onCancel?: () => void;
    submitError?: ReactNode;
    submitText: ReactNode;
};

export const FormFooter: FunctionComponent<PropsWithChildren<FormFooterProperties>> = ({
    disabled = false,
    isSubmitting = false,
    onCancel,
    submitText,
    submitError,
}) => {
    return (
        <div>
            <div className="flex flex-col place-items-end items-center gap-3 rounded-lg bg-gray-50 p-4 sm:mt-6 sm:flex-row-reverse sm:p-3">
                <Button disabled={disabled} style={'submit'} thinking={isSubmitting}>
                    {submitText}
                </Button>

                {onCancel && (
                    <Button onClick={onCancel} style={'cancel'}>
                        <FormattedMessage id="BUTTON_CANCEL" />
                    </Button>
                )}

                {submitError && <ErrorMessage>{submitError}</ErrorMessage>}
            </div>
        </div>
    );
};
